import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/api";
import { useI18n } from "@/i18n";

/* Admin-only inline correction of a checklist row (player name / team). */
export default function CardRowEditor({ row, onSaved, onCancel }) {
  const { t } = useI18n();
  const [name, setName] = useState(row.player_name || "");
  const [team, setTeam] = useState(row.team || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.patch(`/admin/cards/${row.card_id}`, { player_name_raw: name, team_raw: team });
      toast.success(t("sets.edit_saved"));
      onSaved(r.data.card);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-1" data-testid={`card-edit-form-${row.card_id}`}>
      <input value={name} onChange={(e) => setName(e.target.value)} className="wl-mono w-44 border border-[var(--wl-line)] bg-[var(--wl-panel)] px-2 py-0.5 text-[10.5px] text-[var(--wl-text)] outline-none focus:border-[var(--wl-accent)]" placeholder={t("sets.player")} data-testid={`card-edit-name-${row.card_id}`} />
      <input value={team} onChange={(e) => setTeam(e.target.value)} className="wl-mono w-36 border border-[var(--wl-line)] bg-[var(--wl-panel)] px-2 py-0.5 text-[10.5px] text-[var(--wl-text)] outline-none focus:border-[var(--wl-accent)]" placeholder={t("sets.team")} data-testid={`card-edit-team-${row.card_id}`} />
      <button type="button" onClick={save} disabled={busy || !name.trim()} className="wl-mono border border-[var(--wl-accent)] px-2 py-0.5 text-[9.5px] uppercase text-[var(--wl-accent)] disabled:opacity-50" data-testid={`card-edit-save-${row.card_id}`}>{t("sets.save")}</button>
      <button type="button" onClick={onCancel} className="wl-mono border border-[var(--wl-line)] px-2 py-0.5 text-[9.5px] uppercase text-[var(--wl-muted)]" data-testid={`card-edit-cancel-${row.card_id}`}>{t("common.cancel")}</button>
    </div>
  );
}
